import { Cartesian3, Color, PolylineCollection, Matrix4, Transforms, Material, Matrix3, } from "cesium";
/**
 * Axis helper for displaying XYZ guide lines
 */
export class AxisHelper {
    _viewer;
    _polylineCollection;
    _isVisible = false;
    constructor(viewer) {
        this._viewer = viewer;
        this._polylineCollection = new PolylineCollection();
        this._viewer.scene.primitives.add(this._polylineCollection);
    }
    /**
     * Shows XYZ axis at the specified position
     * @param center - Center position in WGS84
     * @param length - Length of each axis line (default: 5m)
     * @param quaternion - Optional rotation quaternion to orient the axes
     */
    show(center, length = 15, quaternion) {
        this.hide();
        // Create ENU transform at center position
        const enuTransform = Transforms.eastNorthUpToFixedFrame(center);
        // If quaternion is provided, apply additional rotation
        let transform = enuTransform;
        if (quaternion) {
            const rotationMatrix = Matrix3.fromQuaternion(quaternion, new Matrix3());
            const rotationMatrix4 = Matrix4.fromRotationTranslation(rotationMatrix, Cartesian3.ZERO, new Matrix4());
            transform = Matrix4.multiply(enuTransform, rotationMatrix4, new Matrix4());
        }
        // X axis (East or rotated X) - Red
        const xEnd = Matrix4.multiplyByPoint(transform, new Cartesian3(length, 0, 0), new Cartesian3());
        this._polylineCollection.add({
            positions: [center, xEnd],
            width: 3,
            material: Material.fromType("Color", {
                color: Color.RED,
            }),
        });
        // Y axis (North or rotated Y) - Green
        const yEnd = Matrix4.multiplyByPoint(transform, new Cartesian3(0, length, 0), new Cartesian3());
        this._polylineCollection.add({
            positions: [center, yEnd],
            width: 3,
            material: Material.fromType("Color", {
                color: Color.GREEN,
            }),
        });
        // Z axis (Up or rotated Z) - Blue
        const zEnd = Matrix4.multiplyByPoint(transform, new Cartesian3(0, 0, length), new Cartesian3());
        this._polylineCollection.add({
            positions: [center, zEnd],
            width: 3,
            material: Material.fromType("Color", {
                color: Color.BLUE,
            }),
        });
        this._isVisible = true;
        this._viewer.scene.requestRender();
    }
    /**
     * Updates axis position and orientation
     * @param center - New center position in WGS84
     * @param length - Length of each axis line
     * @param quaternion - Optional rotation quaternion to orient the axes
     */
    update(center, length = 15, quaternion) {
        if (this._isVisible) {
            this.show(center, length, quaternion);
        }
    }
    /**
     * Hides the axis helper
     */
    hide() {
        this._polylineCollection.removeAll();
        this._isVisible = false;
        this._viewer.scene.requestRender();
    }
    /**
     * Destroys the axis helper
     */
    destroy() {
        this.hide();
        this._viewer.scene.primitives.remove(this._polylineCollection);
    }
    /**
     * Returns whether the axis is currently visible
     */
    get isVisible() {
        return this._isVisible;
    }
}
//# sourceMappingURL=axis-helper.js.map